export type SvgIconName =
  | 'home'
  | 'classes'
  | 'students'
  | 'rules'
  | 'ranking'
  | 'plus'
  | 'search'
  | 'refresh'
  | 'edit'
  | 'save'
  | 'delete'
  | 'import'
  | 'back'
  | 'arrow-up'
  | 'arrow-down'
  | 'record'
  | 'score'
  | 'adopt'
  | 'transfer'
  | 'setting'
  | 'logout'
  | 'detail'
  | 'batch'
  | 'filter'
  | 'paw'
  | 'sparkle'
  | 'crown'
  | 'book';

export interface SvgIconShape {
  paths: string[];
  viewBox?: string;
}

export const SVG_PATHS: Record<SvgIconName, SvgIconShape> = {
  home: {
    paths: ['M3 10.5L12 3L21 10.5V20a1 1 0 0 1-1 1h-4v-6h-6v6H4a1 1 0 0 1-1-1z'],
  },
  classes: {
    paths: ['M4 5h16', 'M4 9h16', 'M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9', 'M7 13h10', 'M7 17h7'],
  },
  students: {
    paths: [
      'M5 7h14',
      'M7 7v13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V7',
      'M10 11a2 2 0 1 0 4 0 2 2 0 0 0-4 0',
      'M12 16v5',
    ],
  },
  rules: {
    paths: [
      'M4 6h16',
      'M4 10h16',
      'M4 14h10',
      'M18 14l2 2-2 2',
      'M6 18a3 3 0 1 0 6 0',
      'M12 18a3 3 0 0 0 6 0',
    ],
  },
  ranking: {
    paths: ['M4 21h16', 'M4 7h16', 'M4 11h16', 'M7 11v10', 'M12 11v10', 'M17 11v10'],
  },
  plus: {
    paths: ['M12 5v14', 'M5 12h14'],
  },
  search: {
    paths: [
      'M11 18a7 7 0 1 1 7-7 7 7 0 0 1-7 7',
      'M20 20l-3-3',
    ],
  },
  refresh: {
    paths: [
      'M4.5 7a8 8 0 0 1 11-3.5',
      'M4 4v3h3',
      'M19.5 17a8 8 0 0 1-11 3.5',
      'M20 20v-3h-3',
    ],
  },
  edit: {
    paths: [
      'M4 20h16',
      'M14.5 5.5l4 4L7.5 20.5H4V17l10.5-11.5',
      'M13 7l4 4',
    ],
  },
  save: {
    paths: [
      'M7 2h10l5 5v15a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2',
      'M17 2v7H7V2M7 22v-6h10v6M9 11h6',
    ],
  },
  delete: {
    paths: [
      'M4 7h16',
      'M9 7v-2a2 2 0 0 1 4 0v2',
      'M8 7h8v12a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2z',
    ],
  },
  import: {
    paths: ['M12 5v10', 'M8 11l4 4 4-4', 'M4 19h16'],
  },
  back: {
    paths: ['M19 12H5', 'M12 5l-7 7 7 7'],
  },
  'arrow-up': {
    paths: ['M12 20V4', 'M6 10l6-6 6 6'],
  },
  'arrow-down': {
    paths: ['M12 4v16', 'M6 14l6 6 6-6'],
  },
  record: {
    paths: [
      'M4 5h16',
      'M6 9h12',
      'M6 13h12',
      'M6 17h8',
    ],
  },
  score: {
    paths: [
      'M12 3v4',
      'M21 9H3',
      'M20 21H4a1 1 0 0 1-1-1v-8h18v8a1 1 0 0 1-1 1z',
      'M7 12v6',
      'M12 10v8',
      'M17 14v4',
    ],
  },
  adopt: {
    paths: [
      'M12 2c-4.4 0-8 3.6-8 8 0 5.8 7 11 8 11s8-5.2 8-11c0-4.4-3.6-8-8-8z',
      'M9 11a3 3 0 1 0 6 0 3 3 0 0 0-6 0z',
    ],
  },
  transfer: {
    paths: [
      'M4 12h16',
      'M12 4l8 8-8 8',
      'M7 12l5 5V7',
    ],
  },
  setting: {
    paths: [
      'M12 16.5a4.5 4.5 0 1 1 4.5-4.5',
      'M19.4 15l0.6 0.2',
      'M16.5 4.1L16 4.8',
      'M7.5 4.1L8 4.8',
      'M4.6 15l-0.6 0.2',
    ],
  },
  logout: {
    paths: ['M10 17l-3 3-3-3', 'M7 20V4', 'M14 8h7v8h-7', 'M14 12h4'],
  },
  detail: {
    paths: ['M12 5v7l4 2', 'M5 6h14', 'M12 17h.01'],
  },
  batch: {
    paths: [
      'M5 7h14',
      'M5 12h10',
      'M5 17h14',
      'M15 7v10',
      'M11 7v10',
      'M19 7v10',
    ],
  },
  filter: {
    paths: ['M4 4h16l-6 7v5l-4 4v-9z'],
  },
  paw: {
    paths: [
      'M12 20c-2.8 0-5-1.9-5-4.4 0-2 1.5-3.3 3.2-3.3 0.7 0 1.3 0.2 1.8 0.5 0.5-0.3 1.1-0.5 1.8-0.5 1.7 0 3.2 1.3 3.2 3.3C17 18.1 14.8 20 12 20z',
      'M7.2 8.2a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8z',
      'M11.1 5.4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z',
      'M16.8 8.2a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8z',
      'M19.5 11.4a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4z',
      'M4.5 11.4a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4z',
    ],
  },
  sparkle: {
    paths: [
      'M12 4l1.9 4.1L18 10l-4.1 1.9L12 16l-1.9-4.1L6 10l4.1-1.9z',
      'M18.5 3.5l0.8 1.8 1.8 0.8-1.8 0.8-0.8 1.8-0.8-1.8-1.8-0.8 1.8-0.8z',
      'M5.5 15.5l0.7 1.5 1.5 0.7-1.5 0.7-0.7 1.5-0.7-1.5-1.5-0.7 1.5-0.7z',
    ],
  },
  crown: {
    paths: [
      'M4 18h16l-1.5-8-4.5 3-2-5-2 5-4.5-3z',
      'M7 18v2',
      'M17 18v2',
      'M9.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z',
      'M14.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z',
    ],
  },
  book: {
    paths: [
      'M12 6c-1.7-1.1-3.7-1.7-6-1.7H4v13h2c2.3 0 4.3.6 6 1.7',
      'M12 6c1.7-1.1 3.7-1.7 6-1.7h2v13h-2c-2.3 0-4.3.6-6 1.7',
      'M12 6v13',
    ],
  },
};
